const config = {
  Panel_interview: '小組面試',
  number_team: '小組人數：',
  interview_location: '面試地點：',
  interview_time: '面試時間：',
  interview_date: '面試日期：',
  Rated_items: '評分項目',
  done: '已完成：',
  details: '學生詳細資料',
  Sname: '學生姓名：',
  application_id: '申請編號：',
  sex: '性別：',
  man: '男',
  girl: '女',
  Birthdate: '出生日期：',
  Parent_material: '家長資料',
  name: '名稱：',
  career: '職業：',
  telephone: '聯絡電話：',
  Native_graduate: '本國畢業生：',
  FATHER: '父親',
  MOTHER: '母親',
  GUARDIAN: '監護人',
  Yes: '是',
  no: '否',
  Writing_evaluation: '文字評價',
  stockpile: '儲存',
  candidate: '輸入對面試者的評價',
  interview_system: '面試系統',
  interview_panel: '面試小組',
  attendees: '只顯示出席者',
  score: '分數',
  select: '您還沒選擇評分項目',
  grade: '分',
  // 假數據內容
  item_one: '请小朋友把積木叠起来。',
  item_two: '请小朋友把珠子連串起来。',
  item_three: '给小朋友拼圄，看看他們是否懂得如何拼組。',
  item_four:
    '讓小朋友自選圖書或玩具﹐觀察在玩耍過程中﹐是否自主性强﹑主動積極。',
  item_five:
    '在小组活動中﹐觀察是否能舆其他人融洽相處﹐是否合群有禮﹐是否表現霸道或者害羞。',
  total: '人數：',
  ApplicationNo: '申請編號',
  InterviewScores: '評分',
  employee: '{{value}}是PLK員工嗎?',
  graduate: '{{value}}是PLK畢業生嗎?',
  WorkPlace: '工作場所',
  FirstLanguage: '第一語言',
  Telephonenight: '電話機(夜間)',
  SingleMode: '單人模式',
  select_task: '選擇題目',
  date: '日期',
  teacher: '老師',
  no_data: '沒有相關資料',
  total_score: '總分',
  go_back_list: '返回列表',
  NameEnglish: '英文名稱：',
  Parent: '家長',
  tit: '提示',
  determine: '確認',
  cancel: '取消',
  resetscore: '您確定要重置分數嗎？',
  Resetsucceeded: '重置成功',
  Resetfailed: '重置失敗',
  InterviewNo: '面試編號：',
  studying: '是否有兄姊在本校就讀?：',
  ChangeRole: '所有角色',
  _ChangeRole: '更改角色',
  no_record: '沒有紀錄'
};

export default config;
